<script setup lang="ts">
import DecisionBadge from '@/pages/banks/my-bank/DecisionBadge.vue'

export type PolicyRow = {
  label: string
  decision?: App.Enums.PartnerBankDecision | null
  notes?: string | null
  suffix?: string | null
}

defineProps<{
  items: PolicyRow[]
}>()
</script>

<template>
  <ul class="divide-surface-100 divide-y">
    <li v-for="item in items" :key="item.label" class="flex flex-col gap-1 py-3 first:pt-0 last:pb-0">
      <div class="flex items-center justify-between gap-4">
        <span class="text-surface-800 font-medium">{{ item.label }}</span>
        <div class="flex shrink-0 items-center gap-3">
          <span v-if="item.suffix" class="text-surface-500 text-sm whitespace-nowrap">{{ item.suffix }}</span>
          <DecisionBadge :decision="item.decision" />
        </div>
      </div>
      <p v-if="item.notes" class="text-surface-500 text-sm">{{ item.notes }}</p>
    </li>
  </ul>
</template>
